module.exports = __webpack_public_path__ + "c5ef5518c5c45f5535305f65af26dd80.MP3";